import styled from 'styled-components';

export default function PaymentOptionCustomInput(props) {
  const { value, setValue, placeholder, width, disabled, textAlign, index } = props;

  function handleClick(e) {
  }

  function handleChange(e) {
    const inputValue = e.target.value;
    if (inputValue === '' || /^[0-9][0-9,]*$/.test(inputValue)) {
      setValue(inputValue, index);
    }
  }

  function handleFocus(e) {
    if (value === '0') setValue('', index);
  }

  function handleBlur(e) {
  }

  return (
    <Input
      type='text'
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      textAlign={textAlign}
      width={width}
      onClick={handleClick}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur} />
  )
}

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	width: ${props => props.width ? `${props.width}px` : '100%'};
	height: 30px;

	padding: 0 8px;

	outline: none;
	border: 1px solid ${props => props.theme.line};
	border-radius: 5px;
	color: ${props => props.theme.text};
	background-color: ${props => props.theme.subBackground};

  text-align: ${props => props.textAlign};

	::placeholder {
		color: ${props => props.disabled ? props.theme.subBackground : props.theme.subText};
	}

  &:disabled {
    background-color: ${props => props.theme.line};
    color: ${props => props.theme.subText};
    cursor: not-allowed;
  }
	
  transition: all 0.3s ease-in-out;
`;